<p-toast></p-toast>
<app-spinner></app-spinner>
<div class="card">
  <ng-container *ngIf="dataTable.length > 0; else no_survey_found">
    <p-table
      [loading]="isLoading"
      #emailTemplateTable
      [columns]="dataColumn"
      [value]="dataTable"
      [paginator]="true"
      dataKey="id"
      styleClass="p-datatable-responsive-demo"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rows]="50"
      [rowsPerPageOptions]="[5, 10, 50]"
      [globalFilterFields]="['name', 'description', 'isActive']"
    >
      <ng-template pTemplate="caption">
        <div class="p-d-flex">
          <span class="p-input-icon-left p-ml-auto">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="emailTemplateTable.filterGlobal($event.target.value, 'contains')"
              placeholder="Search.."
              class="p-inputtext p-component"
            />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th pSortableColumn="name">
            <p-sortIcon field="name"></p-sortIcon>
            Template Name
          </th>
          <th pSortableColumn="isActive">
            <p-sortIcon field="isActive"></p-sortIcon>
            Created By
          </th>
          <th pSortableColumn="createdAt">
            <p-sortIcon field="createdAt"></p-sortIcon>
            Created date
          </th>
          <th pSortableColumn="createdAt">
            <p-sortIcon field="createdAt"></p-sortIcon>
            Last updated by
          </th>
          <th pSortableColumn="createdAt">
            <p-sortIcon field="createdAt"></p-sortIcon>
            Last updated date
          </th>
          <th>Edit</th>
          <th>Delete</th>
          <th>Clone</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td>{{ rowData.templateName }}</td>
          <td>{{ rowData.createdBy }}</td>
          <td>{{ rowData.createdAt?.seconds * 1000 | date: 'short' }}</td>
          <td>{{ rowData.updatedBy }}</td>
          <td>{{ rowData.updatedAt?.seconds * 1000 | date: 'short' }}</td>
          <td>
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-pencil"
              (click)="openEditForm(rowData); $event.stopPropagation()"
              class="p-button-rounded p-button-text"
            ></button>
          </td>
          <td>
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-trash"
              (click)="deleteEmailTemplate(rowData); $event.stopPropagation()"
              class="p-button-rounded p-button-text"
            ></button>
          </td>
          <td>
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-copy"
              (click)="cloneEmailTemplate(rowData); $event.stopPropagation()"
              class="p-button-rounded p-button-text"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
  <ng-template #no_survey_found>
    <div class="noProductFound d-flex-col d-flex-centre">
      <span>No Email templates found.</span>
      <img src="../../../assets/images/core/not-found.png" />
    </div>
  </ng-template>
</div>
